export default import.meta.ROLLDOWN_FILE_URL_kpERy$yII1_yJxl2jSpzDA